import { getFunctions, httpsCallable } from "firebase/functions";
import { auth, app } from "../config/firebase";

export class UserApi {

  public static getDetails = async (): Promise<{ username: string; }> => {
    if (!auth.currentUser) throw new Error("Not signed in");
    const apiCall = httpsCallable<{ }, { username: string; }>(
      getFunctions(app),
      "getUserDetails"
    );
    try {
      const res = await apiCall({ });
      return res.data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to get user details.");
    }
  }
  
  public static setUsername = async (username: string): Promise<string> => {
    if (!auth.currentUser) throw new Error("Not signed in");
    const apiCall = httpsCallable<{ username: string }, { username: string; }>(
      getFunctions(app),
      "setUsername"
    );
    try {
      const res = await apiCall({ username });
      return res.data?.username ?? "";
    } catch (error: any) {
      throw new Error(error.message || "Failed to set username.");
    }
  }

  public static isUsernameAvailable = async (username: string): Promise<boolean> => {
    if (!auth.currentUser) throw new Error("Not signed in");
    const apiCall = httpsCallable<{ username: string }, { available: boolean; }>(
      getFunctions(app),
      "isUsernameAvailable"
    );
    try {
      const res = await apiCall({ username });
      return res.data?.available ?? false;
    } catch (error: any) {
      throw new Error(error.message || "Failed to check username availability.");
    }
  }

  public static sendSignInLinkToEmail = async (email: string): Promise<any> => {
    const apiCall = httpsCallable<{ email: string }, { email: string; }>(
      getFunctions(app),
      "sendSignInLinkToEmail"
    );
    try {
      const res = await apiCall({ email });
      return res.data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to sign-in.");
    }
  }
}
